import Navbar from "@/components/site/Navbar";
import Guide from "@/components/site/Guide";
import Footer from "@/components/site/Footer";
import SurvivorGate from "@/components/site/SurvivorGate";

export default function GuidePage() {
  return (
    <div className="App min-h-screen">
      <Navbar />
      <main className="pt-[72px]">
        <SurvivorGate label="Survivor Field Guide">
          <Guide />
        </SurvivorGate>
      </main>
      <Footer />
    </div>
  );
}
